export default __webpack_public_path__ + "static/media/12S.599cc45b.webp";